<div class="border-b w-full h-full flex aggrid-group-selection-div">
    <mat-chip-listbox #matChipRef [multiple]="multiple" aria-label="Fish selection" class="py-2 px-4 flex-1">
        @for (item of items(); track items()) {
        <mat-chip-option (selectionChange)="selectionChange($event, item)" [selected]="item?.rowGroup">
            {{item?.headerName}}
        </mat-chip-option>
        }
    </mat-chip-listbox>
    <ng-content></ng-content>
</div>